import { AsyncPipe, NgClass } from '@angular/common';
import { Component, DestroyRef, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatToolbar } from '@angular/material/toolbar';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';

import { CommonService, LoginService, WindowService } from '@app/services';
import { SubnavMenuComponent } from '@app/shared/components/subnav-menu/subnav-menu.component';
import { AuthService, User } from '@auth0/auth0-angular';
import { environment } from '@env/environment';
import { InjectionTokens } from '@src/serviceTokens';
import { Observable } from 'rxjs';
import { NavigationMenuComponent } from '../navigation-menu/navigation-menu.component';

@Component({
  selector: 'lausd-header',
  templateUrl: './lausd.header.component.html',
  styleUrls: ['./lausd.header.component.scss'],
  imports: [
    MatToolbar,
    NgClass,
    MatIcon,
    RouterLink,
    NavigationMenuComponent,
    MatButton,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    SubnavMenuComponent,
    AsyncPipe,
  ],
})
export class LausdHeaderComponent implements OnInit {
  protected loginService: LoginService = inject(InjectionTokens.get(LoginService));
  private destroyRef = inject(DestroyRef);

  @Output() toggleSideNav: EventEmitter<boolean> = new EventEmitter<boolean>();

  displayName: string = '';
  isAuthenticated$ = this.auth.isAuthenticated$;
  isPhoneOrTablet$: Observable<boolean> = this.windowService.isPhoneOrTablet$.pipe(takeUntilDestroyed(this.destroyRef));

  currentUser: Observable<User>;
  currentRole: Observable<string>;

  get loggedInAsVendorOrAgency() {
    return this.loginService.isVendor || this.loginService.isAgency;
  }

  get titleText(): string {
    let _titleText = '';

    if (this.loginService.isVendor) {
      _titleText = this.loginService.user.companyName;
    }
    if (this.loginService.isAgency) {
      _titleText = this.loginService.user.agencyName;
    }

    return _titleText;
  }

  get logoLink(): string {
    let _logoLink = '';

    if (this.loginService.isVendor) {
      _logoLink = '/vendor';
    }
    if (this.loginService.isAgency) {
      _logoLink = '/agency';
    }

    return _logoLink;
  }

  constructor(
    private commonService: CommonService,
    private auth: AuthService,
    private router: Router,
    private windowService: WindowService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.currentUser = this.auth.user$.pipe(takeUntilDestroyed(this.destroyRef));
    this.currentRole = this.loginService.roles.pipe(takeUntilDestroyed(this.destroyRef));
  }

  login() {
    this.loginService.login();
  }

  signUp() {
    const url = `https://${environment.auth0Domain}/authorize?prompt=login&response_type=code&client_id=${environment.auth0ClientId}&redirect_uri=${environment.auth0CallbackUrl}&screen_hint=signup`;
    window.location.href = url;
  }

  onLogout(): void {
    this.loginService.logOut();
  }

  toggleNav() {
    this.toggleSideNav.emit(true);
  }
}
